(function (factory) {
	var moduleName = "euenergy";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName, ["jquery"], factory);
		return;
	}

	var moduleExport = factory(window.ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {
	function init(id) {

		if (!ccs_util.isMobile()) {
			return;
		}

		var $entry = $("#" + id);
		var $wrapper = $entry.children();

		function updateScale() {
			$wrapper.css("zoom", 1);

			var entryWidth = $entry.width();
			var wrapperWith = $wrapper.outerWidth(true);
			var scaleRatio = entryWidth / wrapperWith;

			if (scaleRatio < 1) {
				$wrapper.css("zoom", scaleRatio);
			}
		}

		// iframe
		if ($entry.parent().is("body")) {
			updateScale();
			return;
		}

		// div
		$(document).on("ccs.logo-shown",
			function(event, data) {
				if (!$entry.closest("#" + data.entryId).length) {
					return;
				}

				$(window).on("resize.euenergy", updateScale);

				updateScale();
			});

		$(document).on("ccs.logo-hidden",
			function() {
				$(window).off("resize.euenergy");
			});
	}

	return {
		init: init
	};
}));
